<main class="column-layout-container" basepage="primary">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <aside role="region" aria-label="side navigation">
      <div class="menu-top d-flex justify-content-between align-items-center">
        <fui-heading [text]="'header.nav.learn' | translate" [level]="2" fontSize="f7"></fui-heading>
        <button role="status" class="fa-button m-r-10" [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'general.refresh') | translate" placement="bottom" (click)="refresh()">
          <fa-icon icon="sync" class="action refresh circle-icon-btn" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
          <span class="sr-only">{{ refreshing ? ("education.refreshing" | translate) : ("education.refresh" | translate) }}</span>
        </button>
      </div>
      <nav class="nav flex-column" aria-label="side menu">
        <ul class="menu-options">
          <li class="menu-option" [class.active]="displayedSection == 'browse'">
            <a
              class="primary-option"
              tabindex="0"
              href="javascript:void(0);"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('browse')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('browse')"
              (click)="appService.mobileMenuShown = false; switchSection('browse')"
            >
              {{ "education.browse" | translate }}
            </a>
            <div class="menu-suboptions">
              <div class="sub-option d-block">
                <a
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="switchSection('courses')"
                  (keyup.space)="switchSection('courses')"
                  [class.active]="displayedSection == 'courses'"
                  (click)="appService.mobileMenuShown = false; switchSection('courses')"
                >
                  {{ "education.courses" | translate }}
                </a>
              </div>
              <div class="sub-option d-block">
                <a
                  tabindex="0"
                  href="javascript:void(0);"
                  (keyup.enter)="switchSection('lessons')"
                  (keyup.space)="switchSection('lessons')"
                  [class.active]="displayedSection == 'lessons'"
                  (click)="appService.mobileMenuShown = false; switchSection('lessons')"
                >
                  {{ "education.lessons" | translate }}
                </a>
              </div>
            </div>
          </li>
          <li class="menu-option" [class.active]="displayedSection == 'videos'">
            <a
              class="primary-option"
              tabindex="0"
              href="javascript:void(0);"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('videos')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('videos')"
              (click)="appService.mobileMenuShown = false; switchSection('videos')"
            >
              {{ "education.videos" | translate }}
            </a>
            @if (!educationData?.folders?.length) {
              <div class="m-l-30">
                <myp-skeleton-loader type="line" number="27" [useRandomWidth]="true" extraContainerClass="m-y-20"></myp-skeleton-loader>
              </div>
            }
            @if (educationData?.folders) {
              <ul class="menu-suboptions">
                <li class="sub-option d-block">
                  <a
                    tabindex="0"
                    href="javascript:void(0);"
                    (keyup.enter)="chooseFolder('all')"
                    (keyup.space)="chooseFolder('all')"
                    [class.active]="displayedFolder?.title == 'All Videos' && displayedSection == 'videos'"
                    (click)="appService.mobileMenuShown = false; chooseFolder('all')"
                    [attr.aria-current]="displayedFolder?.title == 'All Videos' && displayedSection == 'videos'"
                  >
                    {{ "education.all_videos" | translate }}
                  </a>
                </li>
                @for (folder of displayedFolders; track folder) {
                  <li class="sub-option d-block">
                    <a
                      class="d-flex align-items-center"
                      style="justify-content: left !important"
                      tabindex="0"
                      href="javascript:void(0);"
                      (keyup.enter)="chooseFolder(folder)"
                      (keyup.space)="chooseFolder(folder)"
                      [class.active]="displayedFolder?.title == folder.title && displayedSection == 'videos'"
                      (click)="appService.mobileMenuShown = false; chooseFolder(folder)"
                    >
                      <!-- <div> * -->
                      @if (!folder.icon) {
                        <fa-icon icon="folder" alt="" class="m-r-5" aria-hidden="true"></fa-icon>
                      }
                      @if (folder.icon) {
                        <img [src]="folder.icon" class="m-r-5" style="width: 20px" alt="" aria-hidden="true" />
                      }
                      {{ folder.title }}
                      <!-- </div> -->
                    </a>
                  </li>
                }
                @for (tag of contentService.sidebarTags; track tag) {
                  <li class="sub-option d-block">
                    <a
                      class="d-flex align-items-center"
                      style="justify-content: left !important"
                      tabindex="0"
                      href="javascript:void(0);"
                      (keyup.enter)="chooseTag(tag)"
                      (keyup.space)="chooseTag(tag)"
                      [class.active]="displayedTag?.title == tag.title && displayedSection == 'videos'"
                      (click)="appService.mobileMenuShown = false; chooseTag(tag)"
                    >
                      <!-- <div> -->
                      <strong class="m-r-5">#</strong>
                      {{ tag.title }}
                      <!-- </div> -->
                    </a>
                  </li>
                }
              </ul>
            }
          </li>
          <li class="menu-option" [class.active]="displayedSection == 'mylist'">
            <a
              class="primary-option"
              tabindex="0"
              href="javascript:void(0);"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('mylist')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('mylist')"
              (click)="appService.mobileMenuShown = false; switchSection('mylist')"
            >
              {{ "education.my_library" | translate }}
            </a>
          </li>
          @if (myProductsWithVideos && myProductsWithVideos.length) {
            <li class="menu-option" [class.active]="displayedSection == 'myproducts'">
              <a
                class="primary-option"
                tabindex="0"
                href="javascript:void(0);"
                (keyup.enter)="appService.mobileMenuShown = false; switchSection('myproducts')"
                (keyup.space)="appService.mobileMenuShown = false; switchSection('myproducts')"
                (click)="appService.mobileMenuShown = false; switchSection('myproducts')"
              >
                {{ "education.my_products" | translate }}
              </a>
              @if (displayedSection == "myproducts") {
                <ul class="menu-suboptions">
                  @for (product of myProductsWithVideos; track product) {
                    <li class="sub-option d-block">
                      <a
                        tabindex="0"
                        href="javascript:void(0);"
                        (keyup.enter)="chooseProduct(product)"
                        (keyup.space)="chooseProduct(product)"
                        [class.active]="displayedProduct?.title == product.title && displayedSection == 'myproducts'"
                        (click)="appService.mobileMenuShown = false; chooseProduct(product)"
                      >
                        {{ product.title }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      </nav>
    </aside>
  </div>

  <section class="content animate-in-from-right p-y-5 p-x-10" [class.mobile-shown]="!appService.mobileMenuShown">
    <button class="mobile-back-btn fa-button" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left"></fa-icon>
      {{ "education.video_categories" | translate }}
    </button>
    @if (displayedSection == "mylist") {
      <div class="d-block content-constrained">
        @if (
          !(contentService.userLearnData.saved_courses | keyvalue)?.length &&
          !(contentService.userLearnData.saved_lessons | keyvalue)?.length &&
          !(contentService.userLearnData.saved_videos | keyvalue)?.length &&
          !(contentService.userLearnData.watched_videos | keyvalue)?.length
        ) {
          <div class="fui-layout-pad-content m-t-50">
            <div>
              <fui-heading level="2" fontSize="f7" [text]="'education.my_library' | translate"></fui-heading>
              <span>
                {{ "education.my_library_empty_message" | translate }}
              </span>
            </div>
          </div>
        }
        @if ((contentService.userLearnData.saved_courses | keyvalue)?.length) {
          <div class="m-b-50">
            <fui-heading level="2" fontSize="f7" [text]="'education.my_courses' | translate"></fui-heading>
            <ul class="list-group">
              @for (item of contentService.userLearnData.saved_courses | keyvalue; track item) {
                @if (contentService.courseMap[item.value.learn_group_id]) {
                  <li class="list-group-item bg-transparent border-0 p-0">
                    <myp-learn-list-item [item]="contentService.courseMap[item.value.learn_group_id]"></myp-learn-list-item>
                  </li>
                }
              }
            </ul>
          </div>
        }
        @if ((contentService.userLearnData.saved_lessons | keyvalue)?.length) {
          <div class="m-b-50">
            <fui-heading level="2" fontSize="f7" [text]="'education.my_lessons' | translate"></fui-heading>
            <ul class="list-group">
              @for (item of contentService.userLearnData.saved_lessons | keyvalue; track item) {
                @if (contentService.lessonMap[item.value.learn_group_id]) {
                  <li class="list-group-item bg-transparent border-0 p-0">
                    <myp-learn-list-item [item]="contentService.lessonMap[item.value.learn_group_id]"></myp-learn-list-item>
                  </li>
                }
              }
            </ul>
          </div>
        }
        @if ((contentService.userLearnData.saved_videos | keyvalue)?.length) {
          <div class="m-b-50">
            <fui-heading level="5" [text]="'My Saved Videos'"></fui-heading>
            <div class="p-x-5">
              <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
                @for (item of contentService.userLearnData.saved_videos | keyvalue; track item) {
                  <li class="list-group-item bg-transparent border-0 p-0">
                    <myp-video-grid-item [video]="contentService.videosById[item.value.video_id]"></myp-video-grid-item>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
        @if ((contentService.userLearnData.watched_videos | keyvalue)?.length) {
          <div class="m-b-50">
            <fui-heading level="5" [text]="'Keep Watching...'"></fui-heading>
            <div class="p-x-5">
              <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
                @for (item of contentService.userLearnData.watched_videos | keyvalue; track item) {
                  @if (contentService.videosById[item.value.video_id]) {
                    <li>
                      <myp-video-grid-item [showKeepWatchingActions]="true" [showLibraryActions]="false" [video]="contentService.videosById[item.value.video_id]"></myp-video-grid-item>
                    </li>
                  }
                }
              </ul>
            </div>
          </div>
        }
      </div>
    }

    @if (displayedSection == "videos") {
      @if (displayedFolder && !displayedFolder?.description) {
        <fui-heading level="5" [text]="displayedFolder?.title"></fui-heading>
      }
      @if (displayedTag) {
        <fui-heading level="5" [text]="'#' + displayedTag.title"></fui-heading>
      }
      @if (displayedFolder?.description) {
        <div class="m-b-20">
          <fui-heading level="5" [text]="displayedFolder?.title"></fui-heading>
          <!-- <img [src]="displayedFolder?.image" *ngIf="displayedFolder?.image" class="w-full image-border m-y-10" style="max-width: 400px" /> -->
          <div [innerHTML]="displayedFolder?.description | safe: 'html'"></div>
        </div>
      }
      <!-- START | filter section -->
      <section role="region" aria-label="filter videos">
        <div class="product-filter m-b-20">
          <div class="product-sort">
            <div class="sort-option sort-display one-option">
              <button
                (click)="showFilterOptions = !showFilterOptions"
                class="border-0"
                [class.selected]="showFilterOptions"
                [ngbTooltip]="'education.filter_options' | translate"
                [attr.aria-expanded]="showFilterOptions"
                [attr.aria-controls]="filter_options"
              >
                <fa-icon icon="filter" aria-hidden="true"></fa-icon>
                <span class="sr-only">{{ "education.filter_options" | translate }}</span>
              </button>
            </div>
          </div>
          <div class="filter-input no-max-width">
            <input
              type="text"
              (keyup)="filter()"
              [(ngModel)]="filters.query"
              [placeholder]="'sphere.filter_list' | translate"
              aria-label="The following text field filters the results that follow as you type ...."
            />
            @if (filters.query) {
              <button type="button" class="clear border-0 p-0" (click)="filters.query = ''; filter()">
                <fa-icon icon="times" aria-hidden="true"></fa-icon>
                <span class="sr-only">{{ "education.clear_search" | translate }}</span>
              </button>
            }
          </div>
        </div>
        @if (showFilterOptions) {
          <div class="d-flex flex-wrap m-b-20 learn-content-filters" [ngStyle]="{ opacity: filters.query ? '.5' : '1' }" id="filter_options">
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="product_associated">{{ "education.by_product_associated" | translate }}</label>
              <select
                [disabled]="filters.query ? true : false"
                [class.disabled]="filters.query"
                class="form-control custom-select-sm"
                (change)="filter()"
                [(ngModel)]="filters.product"
                id="product_associated"
              >
                <option value="any">{{ "education.any" | translate }}</option>
                @for (prod of contentService.productsAssociatedWithVideos; track prod) {
                  <option [value]="prod.id">{{ prod.title }}</option>
                }
              </select>
            </div>
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="tag">{{ "education.by_tag" | translate }}</label>
              <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.tag" id="tag">
                <option value="any">{{ "education.any" | translate }}</option>
                @for (tag of contentService.tagsAssociatedWithVideos; track tag) {
                  <option [value]="tag.id">{{ tag.title }}</option>
                }
              </select>
            </div>
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="duration">{{ "education.duration" | translate }}</label>
              <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.duration" id="duration">
                <option value="any">{{ "education.any" | translate }}</option>
                <option value="0_60">{{ "education.under_a_minute" | translate }}</option>
                <option value="60_300">{{ "education.one_to_five_minutes" | translate }}</option>
                <option value="300_600">{{ "education.five_to_ten_minutes" | translate }}</option>
                <option value="600_1800">{{ "education.ten_to_thirty_minutes" | translate }}</option>
                <option value="1800_200000">{{ "education.more_than_thirty_minutes" | translate }}</option>
              </select>
            </div>
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="level">{{ "education.level" | translate }}</label>
              <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.level" id="level">
                <option value="any">{{ "education.any" | translate }}</option>
                <option value="none">{{ "education.none_set" | translate }}</option>
                <option value="0">{{ "education.easy" | translate }}</option>
                <option value="1">{{ "education.intermediate" | translate }}</option>
                <option value="2">{{ "education.difficult" | translate }}</option>
                <option value="3">{{ "education.expert" | translate }}</option>
              </select>
            </div>
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="sort_by">{{ "education.sort_by" | translate }}</label>
              <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.sort_by" id="sort_by">
                <option value="date">{{ "education.date" | translate }}</option>
                <option value="title">{{ "education.title" | translate }}</option>
              </select>
            </div>
            <div class="form-group m-r-10">
              <label class="t-12 text-muted mb-0" for="sort_direction">{{ "education.sort_direction" | translate }}</label>
              <select
                [disabled]="filters.query ? true : false"
                [class.disabled]="filters.query"
                class="form-control custom-select-sm"
                (change)="filter()"
                [(ngModel)]="filters.sort_order"
                id="sort_direction"
              >
                <option value="desc">{{ "education.descending" | translate }}</option>
                <option value="asc">{{ "education.ascending" | translate }}</option>
              </select>
            </div>
            <div class="form-group m-r-10">
              <div class="t-12 text-muted mb-0">&nbsp;</div>
              <button type="button" class="btn btn-primary btn-sm" (click)="resetFilters()" style="letter-spacing: 0.4px">{{ "education.reset_filters" | translate }}</button>
            </div>
          </div>
        }
        @if (displayedVideos) {
          <div class="results-count sr-only" aria-live="assertive">{{ "education.records_available" | translate: { count: displayedVideos.length } }}</div>
        }
      </section>
      <!-- END | filter section -->
      @if (!displayedVideos?.length) {
        <myp-skeleton-loader type="learn-video" number="9" class="grid-container wider pad-10"></myp-skeleton-loader>
      }
      <div class="p-x-5">
        <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
          @for (item of displayedVideos; track item) {
            <li>
              <myp-video-grid-item [video]="item"></myp-video-grid-item>
            </li>
          }
        </ul>
      </div>
      @if ((displayedFolder || displayedTag) && totalPages) {
        <div class="d-flex justify-content-center m-b-20 m-t-100">
          <div class="d-flex align-items-center">
            <div style="width: 30px">
              @if (page != 0) {
                <button class="fa-button focus" (click)="paginate('previous')">
                  <fa-icon class="circle-icon-btn" icon="chevron-left"></fa-icon>
                  <span class="custom-sr-only">previous page</span>
                </button>
              }
            </div>
            <small class="d-block m-x-10">
              <span class="custom-sr-only">{{ "education.show_videos_from" | translate }}</span>
              {{ page * limit }} - {{ page * limit + limit > totalVideos ? totalVideos : page * limit + limit }} of {{ totalVideos }}
            </small>
            <div style="width: 30px">
              @if (page != totalPages) {
                <button class="fa-button focus" (click)="paginate('next')">
                  <fa-icon class="circle-icon-btn" icon="chevron-right"></fa-icon>
                  <span class="custom-sr-only">{{ "education.next_page" | translate }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      }
    }

    @if (displayedSection == "browse") {
      <fui-heading level="2" fontSize="f7" [text]="'education.browse' | translate"></fui-heading>
      @if (contentService.courses && contentService.courses.length && productService.s16Released && educationData.folders[0] && educationData.folders[0].string_id == "studio_one_6_features") {
        <div class="featured-carousel c-white" [style]="'background-image: url(https://mypresonus.s3.amazonaws.com/images/s16-banner.png);'">
          <br />
          <br />
          <h5 class="brandfont-bold">{{ "education.studio_one_6_available" | translate }}</h5>
          {{ "education.check_out_new_features" | translate }}
          <span class="btn btn-primary m-t-20 m-b-30" (click)="chooseFolder(educationData.folders[0])">{{ "education.view_studio_one_6_videos" | translate }}</span>
          <br />
          <br />
        </div>
      }
      <div class="d-flex align-items-center justify-content-between m-t-20">
        <fui-heading level="3" fontSize="f6" [text]="'education.featured_courses' | translate"></fui-heading>
        <span class="section-header-link" (click)="switchSection('courses')">{{ "education.view_all" | translate }}</span>
      </div>
      <!-- <h2 class="section-header m-b-10 m-t-20">
    Featured Courses
    <span class="section-header-link" (click)="switchSection('courses')">View All</span>
  </h2> -->
      @if (!contentService.courses?.length) {
        <myp-skeleton-loader type="carousel" extraContainerClass="m-y-20"></myp-skeleton-loader>
      }
      @if (contentService.courses?.length) {
        <div class="featured-carousel" [style]="'background-image: url(' + contentService.courses[selectedCourseIndex].image + ');'">
          <div class="text-center p-10 dark-trans-bg border-radius10 m-x-30 c-white m-b-20">
            <fui-heading level="4" textAlign="center" color="white" [text]="contentService.courses[selectedCourseIndex].title"></fui-heading>
            <!-- <h3 class="bold">{{ contentService.courses[selectedCourseIndex].title }}</h3> -->
            <span class="brandfont-bold">{{ contentService.courses[selectedCourseIndex].lessons?.length }} Lessons</span>
            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
            <span class="brandfont-bold">{{ contentService.courses[selectedCourseIndex].totalVideos }} Videos</span>
            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
            <span class="brandfont-bold">{{ helperService.hhmmss(contentService.courses[selectedCourseIndex].runtime, true) }}</span>
            <div class="m-x-30 m-t-10">{{ contentService.courses[selectedCourseIndex].snippet }}</div>
            <span class="btn btn-primary m-t-20" [routerLink]="['/learn/course/', contentService.courses[selectedCourseIndex].id]">View Course</span>
          </div>
        </div>
      }
      <div class="m-t-10 d-flex justify-content-center">
        @for (item of contentService.courses; track item; let i = $index) {
          <span (click)="selectedCourseIndex = i" class="carousel-dot" [class.selected]="selectedCourseIndex == i"></span>
        }
      </div>
      <div class="d-flex align-items-center justify-content-between m-t-20">
        <fui-heading level="3" fontSize="f6" [text]="'education.featured_lessons' | translate"></fui-heading>
        <span class="section-header-link" (click)="switchSection('lessons')">{{ "education.view_all" | translate }}</span>
      </div>
      @if (!featuredLessons?.length) {
        <myp-skeleton-loader extraContainerClass="m-y-20" number="5" type="list-item-large"></myp-skeleton-loader>
      }
      <ul class="list-group">
        @for (lesson of featuredLessons || []; track lesson) {
          <li class="list-group-item bg-transparent border-0 p-0">
            <myp-learn-list-item [showAddToList]="true" [item]="lesson"></myp-learn-list-item>
          </li>
        }
      </ul>
      <div class="d-flex align-items-center justify-content-between m-t-20">
        <fui-heading level="3" fontSize="f6" [text]="'education.latest_videos' | translate"></fui-heading>
        <span class="section-header-link" (click)="switchSection('videos')">{{ "education.view_all" | translate }}</span>
      </div>
      @if (!featuredVideos?.length) {
        <myp-skeleton-loader number="9" class="grid-container wider pad-10" type="learn-video"></myp-skeleton-loader>
      }
      <div class="p-x-5">
        <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
          @for (video of featuredVideos; track video) {
            <li>
              <myp-video-grid-item [video]="video"></myp-video-grid-item>
            </li>
          }
        </ul>
      </div>
    }
    @if (displayedSection == "courses") {
      <fui-heading level="2" fontSize="f7" [text]="'education.courses' | translate"></fui-heading>
      @if (!educationData?.courses?.length) {
        <myp-skeleton-loader extraContainerClass="m-y-20" number="2" type="list-item-large"></myp-skeleton-loader>
      }
      <ul class="list-group">
        @for (course of educationData?.courses || []; track course) {
          <li class="list-group-item bg-transparent border-0 p-0">
            <myp-learn-list-item [showAddToList]="true" [item]="course"></myp-learn-list-item>
          </li>
        }
      </ul>
    }
    @if (displayedSection == "lessons") {
      <section class="section-lesson">
        <fui-heading level="2" fontSize="f7" [text]="'education.lessons' | translate"></fui-heading>
        @if (!educationData?.lessons?.length) {
          <myp-skeleton-loader extraContainerClass="m-y-20" number="9" type="list-item-large"></myp-skeleton-loader>
        }
        <ul class="list-group">
          @for (lesson of educationData?.lessons || []; track lesson) {
            <li class="list-group-item bg-transparent border-0 p-0">
              <myp-learn-list-item [showAddToList]="true" [item]="lesson"></myp-learn-list-item>
            </li>
          }
        </ul>
      </section>
    }
    @if (displayedSection == "myproducts") {
      <fui-heading level="5" [text]="'education.my_products_title' | translate: { title: displayedProduct?.title }"></fui-heading>
      @if (!displayedVideos?.length) {
        <myp-skeleton-loader type="learn-video" class="grid-container wider pad-10" number="9"></myp-skeleton-loader>
      }
      <div class="p-x-5">
        <ul class="list-inline grid-container even-rows wider pad-10 video-grid">
          @for (item of displayedVideos; track item) {
            <li>
              <myp-video-grid-item [video]="item"></myp-video-grid-item>
            </li>
          }
        </ul>
      </div>
    }
  </section>
</main>

<!-- Reusable filter content template -->
